/**
 * 红眼工具控制器（补齐 registry.ts 早先登记的占位工具）。
 *
 * 交互只有 down：点一下，app/red-eye-fill.ts 去判定+修复。
 * 同步 CPU 计算（不像磁性/内容识别那些需要 wasm），不需要忙碌位保护。
 */
import { redEyeFix } from '../../app/red-eye-fill';
import type { AppStore } from '../../app/store';
import type { ToolManager } from './registry';

export interface RedEyeDeps {
  readonly store: AppStore;
  readonly tools: ToolManager;
  readonly requestRender: () => void;
}

export class RedEyeToolController {
  readonly #deps: RedEyeDeps;

  constructor(deps: RedEyeDeps) {
    this.#deps = deps;
  }

  handlePointer(phase: 'down' | 'move' | 'up' | 'double', point: { x: number; y: number }): boolean {
    const { store, tools } = this.#deps;
    if (tools.active.id !== 'redEye') return false;
    if (phase !== 'down') return true;
    if (store.document === null) return true;

    const radius = tools.getOption('redEye', 'size') as number;
    const changed = redEyeFix(store, point.x, point.y, radius / 2);
    if (changed) this.#deps.requestRender();
    return true;
  }
}
